module.exports = __webpack_public_path__ + "img/katarina_amenities_5.8a31e527.jpg";